<template>
  <v-card flat class=" px-5 ">
    <v-row class="pb-0">
      <v-col cols="8" md="8">
        <v-card flat style="color: #f2f3f9">
          <v-text-field flat background-color="#F6F8FC" solo class="feild " prepend-inner-icon="mdi-magnify"
            label="Search.." v-model="search" @input="Filter" single-line>
          </v-text-field>
        </v-card>
      </v-col>

    </v-row>

    <v-card flat class=" mt-8"> 


      <v-row>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h ">Español</span><span class="text_heading_ttb"> (Latinoamérica)</span></div>

        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">English</span></div>

        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">Portuguese</span></div>

        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">Deutsch</span></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">French</span></div>

        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h ">Scandinavian</span></div>

        </v-col>
        <v-col cols="12" md="6" class="mb-14 pt-0">
          <div><span class="style_text_h ">Czech</span></div>

        </v-col>
        <v-col cols="12" md="6" class="mb-14 pt-0">
          <div><span class="style_text_h ">Spanish</span></div>

        </v-col>
        <v-col cols="12" md="6" class="mb-14 pt-0">
          <div><span class="style_text_h ">Japanese</span></div>

        </v-col>
        <v-col cols="12" md="6" class="mb-14 pt-0">
          <div><span class="style_text_h ">German</span></div>

        </v-col>

      </v-row>
    </v-card>
  </v-card>
</template>

<script>
export default {

}
</script>

<style scoped>
.style_text_h {
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #222222;

}

.feild {

  background-color: #F6F8FC;
  border: 1px solid #F2F3F9;
  border-radius: 6px;
  height: 50px;

}

.text_heading_ttb {
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: rgba(8, 8, 22, 0.38);
}
</style>